<template>
    <div>
        <div class="row">
            <div class="col-lg-5">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-no-kartu">No. Kartu BPJS</label>
                    <div class="col-lg-8">
                        <input type="text" v-model="form.no_bpjs" class="form-control" id="input-no-kartu" readonly>
                        <small v-if="validation.dokter_poli" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Dokter poli harus diisi!</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-no-rm">Nomor RM</label>
                    <div class="col-lg-8">
                        <input type="text" v-model="form.nomor_rm" class="form-control" id="input-no-rm" readonly>
                        <small v-if="validation.nomor_rm" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Nomor RM harus diisi!</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-nama-pasien">Nama Pasien</label>
                    <div class="col-lg-8">
                        <input type="text" v-model="form.nama_pasien" class="form-control" id="input-nama-pasien">
                        <small v-if="validation.nama_pasien" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Nama pasien harus diisi!</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-5" v-if="!error">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="select-kategori-pasien">Kategori Pasien</label>
                    <div class="col-lg-8">
                        <b-form-select id="select-kategori-pasien" class="form-select" v-model="form.kategori_pasien" :options="option_kategori_pasien" @change="setKategori"></b-form-select>
                        <small v-if="validation.kategori_pasien" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Kategori pasien harus diisi!</small>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="error" class="alert alert-danger" role="alert">{{ error_message }}</div>

        <div class="row">
            <div class="col-lg-5">
                <div v-if="form.kategori_pasien != 'null'" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-tgl-berobat">Tanggal Berobat</label>
                    <div class="col-lg-8">
                        <input type="date" v-model="form.tgl_berobat" class="form-control" id="input-tgl-berobat" @change="getPoli">
                        <small v-if="validation.tgl_berobat" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Tanggal berobat harus diisi!</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div v-if="form.tgl_berobat && kategori == 2" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-no-rujukan">No. Rujukan / No. Surat Kontrol</label>
                    <div class="col-lg-8">
                        <b-form-select v-if="!manual_rujukan" id="select-kategori-pasien" class="form-select" v-model="form.no_rujukan" :options="option_no_rujukan" @change="cekRujukan"></b-form-select>
                        <input v-if="manual_rujukan" type="text" v-model="form.no_rujukan" @change="cekRujukan" class="form-control" id="input-no-rujukan" placeholder="Masukkan No. Rujukan / No. Surat Kontrol">
                        <small v-if="validation.no_rujukan" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Rujukan harus diisi!</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5">
                <div v-if="(form.tgl_berobat && kategori != 2) || form.no_rujukan != 'null'" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Poliklinik Tujuan</label>
                    <div class="col-lg-8">
                        <b-form-select id="select-poli" class="form-select" v-model="form.poli_tujuan" :options="option_poli" @change="getDokter"></b-form-select>
                        <small v-if="validation.poli_tujuan" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Poli tujuan harus diisi!</small>
                    </div>
                </div>
            </div>
            <div class="col-lg-5">
                <div v-if="form.poli_tujuan != 'null'" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="select-dokter">Dokter Poli</label>
                    <div class="col-lg-8">
                        <b-form-select id="select-dokter" class="form-select" v-model="form.dokter_poli" :options="option_dokter" @change="checkKuota"></b-form-select>
                        <small v-if="validation.dokter_poli" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">Dokter poli harus diisi!</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5">
                <div v-if="form.dokter_poli != 'null'" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-no-hp">No. Telepon/HP</label>
                    <div class="col-lg-8">
                        <input type="text" v-model="form.no_hp" class="form-control" id="input-no-hp">
                        <small v-if="validation.no_hp" tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">No. HP harus diisi!</small>
                        <small tabindex="-1" id="input-group-1__BV_description_" class="form-text text-danger">(* Nomor yang bisa dihubungi)</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-5">
                <div v-if="form.no_hp && form.dokter_poli != 'null'" class="form-group row pb-4">
                    <label class="col-lg-3 text-lg-end pt-2" for="input-alamat-email"></label>
                    <div class="col-lg-8">
                        <b-button variant="success" class="col-lg-4" @click="goRegister">Daftar</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormPasien",
    props: {
        data_pasien: {
            type: Object,
            default(rawProps) {
                return {}
            }
        },
        no_rujukan: {
            type: Array,
            default(rawProps) {
                return {}
            }
        },
        onRegisterSuccess: {
            type: Function,
            default() {
                return 'Default function'
            }
        },
    },
    watch: {
        data_pasien: {
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val, oldVal) {
                const { Medrec, Bod, Firstname, kategori_pasien, AskesNo, Phone, nomor_ktp } = val;
                this.form.nomor_rm = Medrec;
                this.form.tgl_lahir = moment(Bod).format("YYYY-MM-DD");
                this.form.nama_pasien = Firstname
                this.form.kategori_pasien = 'null'
                this.form.no_bpjs = AskesNo
                this.form.no_hp = Phone
                this.form.nomor_ktp = nomor_ktp
                this.error = Medrec ? false : true
                this.error_message = Medrec ? '' : ''
            }
        },
        no_rujukan: {
            immediate: true,
            handler (val, oldVal) {
                if (val.length > 0) {
                    this.option_no_rujukan = [
                        {value: 'null', text: '[ Pilih ]'},
                        {value: 'manual', text: 'Input Manual'}
                    ]
                    for (let index = 0; index < val.length; index++) {
                        const nr = val[index];
                        this.option_no_rujukan.push({value: nr, text: nr})
                    }
                }
            }
        }
    },
    data() {
        return {
            form: {
                nomor_rm: null,
                nomor_ktp: null,
                tgl_lahir: null,
                nama_pasien: null,
                no_rujukan: 'null',
                kategori_pasien: 'null',
                poli_tujuan: 'null',
                no_bpjs: null,
                dokter_poli: 'null',
                no_hp: null,
                tgl_berobat: null,
                pasien_baru: false,
                jenis_kunjungan: '',
            },
            validation: {
                nomor_rm: false,
                tgl_lahir: false,
                nama_pasien: false,
                no_rujukan: false,
                kategori_pasien: false,
                poli_tujuan: false,
                no_bpjs: false,
                dokter_poli: false,
                no_hp: false,
                tgl_berobat: false,
            },
            option_kategori_pasien: [{value: 'null', text: '[ Pilih ]'}],
            option_poli: [{value: 'null', text: '[ Pilih ]'}],
            option_dokter: [{value: 'null', text: '[ Pilih ]'}],
            option_no_rujukan: [
                {value: 'null', text: '[ Pilih ]'},
                {value: 'manual', text: 'Input Manual'},
            ],
            error: false,
            error_message: '',
            jadwal_dokter: [],
            poli_tujuan: "",
            arr_kategori: [],
            kategori: 0,
            rujukan: null,
            manual_rujukan: false,
        }
    },
    created() {
        this.getKategoriPasien()
    },
    methods: {
        getKategoriPasien() {
            this.$isLoading(true)
            let uri = '/api/get_kategori_pasien'
            this.axios.get(uri).then(response => {
                this.option_kategori_pasien = [{value: 'null', text: '[ Pilih ]'}]

                let kateogori_pasien = response.data.metode_pendaftaran.konfigurasi_loket
                kateogori_pasien.forEach(kp => {
                    this.arr_kategori[kp.loket_pendaftaran.id] = kp.loket_pendaftaran.loket.kategori.id
                    this.option_kategori_pasien.push({value: kp.loket_pendaftaran.id, text: kp.loket_pendaftaran.nama})
                });
                this.$isLoading(false)
            })
        },
        getPoli() {
            this.$isLoading(true)
            this.option_poli = [{value: 'null', text: '[ Pilih ]'}]
            this.option_dokter = [{value: 'null', text: '[ Pilih ]'}]

            let uri = '/api/getpoli?tgl_berobat=' + this.form.tgl_berobat + '&kategori=' + this.kategori
            this.axios.get(uri).then(response => {
                let all_poli = response.data.jadwal_poli

                console.log('all_poli:', all_poli)
                all_poli.forEach(ap => {
                    if (ap.poli_data.KdBPJS) {
                        this.option_poli.push({value: ap.kode_sub_spesialis, text: ap.nama_sub_spesialis})
                    }
                });
                this.$isLoading(false)
            })
        },
        getDokter() {
            if (this.kategori == 2) {
                if (this.rujukan) {
                    if ('poliRujukan' in this.rujukan) {
                        if (this.form.poli_tujuan != this.rujukan.poliRujukan.kode) {
                            this.$swal.fire({
                                title: 'Informasi',
                                text: 'Rujukan ditujukan untuk poli ' + this.rujukan.poliRujukan.nama,
                                icon: 'warning',
                                confirmButtonText: 'OK'
                            })

                            this.form.poli_tujuan = this.rujukan.poliRujukan.kode
                        }
                    }

                    if ('poliTujuan' in this.rujukan) {
                        if (this.form.poli_tujuan != this.rujukan.poliTujuan) {
                            this.$swal.fire({
                                title: 'Informasi',
                                text: 'Rujukan ditujukan untuk poli ' + this.rujukan.namaPoliTujuan,
                                icon: 'warning',
                                confirmButtonText: 'OK'
                            })

                            this.form.poli_tujuan = this.rujukan.poliTujuan
                        }
                    }
                }
            }

            this.$isLoading(true)
            let uri = '/api/getdokter?poli=' + this.form.poli_tujuan + '&tgl_berobat=' + this.form.tgl_berobat + '&kategori=' + this.kategori
            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.option_dokter = [{value: 'null', text: '[ Pilih ]'}]

                    let dokter = response.data.jadwal_dokter
                    dokter.forEach(dok => {
                        let antrean = dok.antrean ? dok.antrean.length : 0
                        this.option_dokter.push({value: dok.id, text: dok.nama_dokter + ' (' + dok.jadwal + ') - sisa kuota: ' + (dok.kapasitas_pasien - antrean)})
                        this.jadwal_dokter[dok.id] = dok
                    });
                }

                this.$isLoading(false)
            })
        },
        checkKuota() {
            let jadwal = this.jadwal_dokter[this.form.dokter_poli] != undefined ? this.jadwal_dokter[this.form.dokter_poli] : null
            console.log('jadwal:', jadwal)
            if (jadwal) {
                let antrean = jadwal.antrean.length
                let kapasitas_pasien = jadwal.kapasitas_pasien
                let sisa_kuota = kapasitas_pasien - antrean

                if (sisa_kuota < 1) {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Kuota tidak tersedia!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            }
        },
        goRegister() {
            let validation = this.validateKategori()

            if (validation) {
                this.$isLoading(true)
                let uri = '/api/reg_pasien'

                this.axios.post(uri, this.form).then(response => {
                    if (response.data.status == 'success') {
                        const data_register = response.data.data_register

                        if (this.onRegisterSuccess) {
                            this.onRegisterSuccess(data_register);
                        }
                    } else {
                        this.$swal.fire({
                            title: 'Pendaftaran Tidak Dapat Diproses',
                            text: response.data.message,
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        });
                    }
                    this.$isLoading(false)
                }).catch(error => {
                    this.$isLoading(false)
                    let err_response = error.response
                    let errors = Object.entries(err_response.data.errors)

                    this.validation = {
                        nomor_rm: false,
                        tgl_lahir: false,
                        nama_pasien: false,
                        no_rujukan: false,
                        kategori_pasien: false,
                        poli_tujuan: false,
                        no_bpjs: false,
                        dokter_poli: false,
                        no_hp: false,
                        tgl_berobat: false,
                    }

                    errors.forEach((value, key) => {
                        if (value[0] == 'nomor_rm') {
                            this.validation.nomor_rm = true
                        }

                        if (value[0] == 'tgl_lahir') {
                            this.validation.tgl_lahir = true
                        }

                        if (value[0] == 'nama_pasien') {
                            this.validation.nama_pasien = true
                        }

                        if (value[0] == 'no_rujukan') {
                            this.validation.no_rujukan = true
                        }

                        if (value[0] == 'kategori_pasien') {
                            this.validation.kategori_pasien = true
                        }

                        if (value[0] == 'poli_tujuan') {
                            this.validation.poli_tujuan = true
                        }

                        if (value[0] == 'no_bpjs') {
                            this.validation.no_bpjs = true
                        }

                        if (value[0] == 'dokter_poli') {
                            this.validation.dokter_poli = true
                        }

                        if (value[0] == 'no_hp') {
                            this.validation.no_hp = true
                        }

                        if (value[0] == 'tgl_berobat') {
                            this.validation.tgl_berobat = true
                        }
                    });

                    alert('Pendaftaran gagal. Silahkan cek ulang form pendaftaran.')
                })
            }
        },
        setKategori() {
            this.kategori = this.arr_kategori[this.form.kategori_pasien]
        },
        cekRujukan() {
            if (this.form.no_rujukan) {
                if (this.form.no_rujukan == 'manual') {
                    this.form.no_rujukan = ''
                    this.manual_rujukan = true
                } else {
                    this.$isLoading(true)
                    let uri = `/api/cek-rujukan?rujukan=${this.form.no_rujukan}&tanggal_periksa=${this.form.tgl_berobat}`

                    this.axios.get(uri).then(response => {
                        if (response.data.status == 'success') {
                            this.rujukan = response.data.rujukan
                            if ('response' in this.rujukan) {
                                if (this.rujukan.response == null) {
                                    this.$swal.fire({
                                        title: 'Error!',
                                        text: 'Rujukan tidak ditemukan!',
                                        icon: 'error',
                                        confirmButtonText: 'OK'
                                    })

                                    this.rujukan = null
                                }
                            } else {
                                this.form.jenis_kunjungan = response.data.jenis_kunjungan

                                switch (this.form.jenis_kunjungan) {
                                    case '3':
                                    case 3:
                                        this.form.poli_tujuan = this.rujukan.poliTujuan
                                        break;
                                    case '2':
                                    case 2:
                                        this.form.poli_tujuan = this.rujukan.poliTujuan
                                        break;
                                    case '1':
                                    case 1:
                                        this.form.poli_tujuan = this.rujukan.poliRujukan.kode
                                        break;
                                
                                    default:
                                        this.form.poli_tujuan = 'null'
                                        break;
                                }

                                this.getDokter()
                            }
                        } else {
                            this.form.no_rujukan = 'null'
                            this.$swal.fire({
                                title: 'Pendaftaran Tidak Dapat Diproses',
                                text: response.data.message,
                                icon: 'error',
                                confirmButtonText: 'OK'
                            })

                            this.rujukan = null
                        }

                        this.$isLoading(false)
                    })
                }
            } else {
                this.rujukan = null
            }
        },
        validateKategori() {
            if (this.kategori == 2) {
                if (this.form.no_rujukan == 0) {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Silahkan isi No. Rujukan terlebih dahulu!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })

                    return false
                } else if (this.rujukan == null) {
                    this.$swal.fire({
                        title: 'Error!',
                        text: 'Rujukan tidak ditemukan!',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })

                    return false
                }
            }

            return true
        }
    }
}
</script>